exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".head {\n  background-color: #1464f6; }\n\n.body {\n  background-color: #eee; }\n  .body div input {\n    border: none !important;\n    background-color: #eee;\n    color: black; }\n\n:host /deep/ app-auto-complete-denial-code .code-externo {\n  position: fixed;\n  z-index: 9; }\n\n:host /deep/ app-auto-complete-denial-code input {\n  height: 27px !important; }\n\n:host /deep/ app-auto-complete-denial-code .list {\n  z-index: 99;\n  width: 27%; }\n\n.rollback-reason-alert {\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  padding: 10px;\n  border-radius: 4px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/posting/modal-charges-details/modal-charges-details.component.scss
// module id = 1979
// module chunks = 66